<!--  -->
<template>
  <div>
    <div class="form_box">
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="企业名">
          <el-input v-model="form.company_name" />
        </el-form-item>
        <el-form-item label="是否打卡">
          <el-table-column
            align="center"
            prop="monitor_status"
            label="是否打卡"
            width="180"
          >
            <template>
              <div style="position: relative; display: inline-block;">
                <el-switch
                  v-model="form.ster"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                />
                <div
                  v-if="form.ster"
                  style="color: #fff;position: absolute;top: 2px;left: 7px;"
                >已打卡</div>
                <div
                  v-else
                  style="color: #fff;position: absolute;top: 2px;right: 7px;"
                >未打卡</div>
              </div>

            </template>
          </el-table-column>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addcread">立即创建</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div style="padding:0 40px">
      <el-table
        :data="tableData"
        style="width:100%; height: 100%;"
        border
        max-height="500"
      >
        <el-table-column
          align="center"
          label="企业名"
        >
          <template slot-scope="scope">
            <span v-if="!scope.row.show">{{ scope.row.company_name }}</span>
            <el-input
              v-else
              v-model="company_name"
            />
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="monitor_status"
          label="是否打卡"
          width="180"
        >
          <template slot-scope="scope">
            <div style="position: relative; display: inline-block;">
              <el-switch
                v-model="scope.row.ster"
                active-color="#13ce66"
                inactive-color="#ff4949"
                @change="naclick(scope.row)"
              />
              <div
                v-if="scope.row.ster"
                style="color: #fff;position: absolute;top: 2px;left: 7px;"
              >已打卡</div>
              <div
                v-else
                style="color: #fff;position: absolute;top: 2px;right: 7px;"
              >未打卡</div>
            </div>

          </template>
        </el-table-column>

        <el-table-column
          :key="mathRandom"
          label="操作"
          align="center"
        >
          <template slot-scope="scope">
            <span v-show="!scope.row.show">
              <el-button
                type="text"
                size="small"
                @click.native.prevent="modifyAccount(scope.$index, scope.row)"
              >
                修改
              </el-button>
              <el-button
                type="text"
                size="small"
                @click.native.prevent="deleteAccount(scope.row.id)"
              >
                删除
              </el-button>
            </span>
            <span v-show="scope.row.show">
              <el-button
                type="text"
                size="small"
                @click.native.prevent="cancelAccount(scope.$index)"
              >
                取消修改
              </el-button>
              <el-button
                type="text"
                size="small"
                @click.native.prevent="confirmAccount(scope.$index,scope.row)"
              >
                确认修改
              </el-button>
            </span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import { wechatcompany, wechatcompanying, wechatcomupdata, deletetestwechatr } from '@/api/providerAccountManagement/servicePorviderList.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: {
    PaginationRight
  },
  data() {
    return {
      form: {
        company_name: '',
        ster: true
      },
      stutes: null,
      pwdFlag: true, // 密码标示 true表示当前是密码形式
      account_name: '',
      login_pwd: '',
      pay_pwd: '',
      mathRandom: null,

      tableData: [],
      query: {
        page: 1,
        page_size: 10,
        company_name: null
      },
      total: null,

      company_name: '',
      ster: null
    }
  },
  created() {
    this.accountlist()
  },
  mounted() {

  },
  methods: {
    async accountlist() {
      const data = await wechatcompanying(this.query)
      console.log('data', data.data.list)
      this.tableData = data.data.list
      this.total = data.data.total
      for (let i = 0; i < this.tableData.length; i++) {
        this.tableData[i].show = false
        if (this.tableData[i].clock_in === 1) {
          this.tableData[i].ster = true
        } else {
          this.tableData[i].ster = false
        }
      }
      console.log('this.tableData ', this.tableData)
    },
    async addcread() {
      if (this.form.company_name === '') {
        this.$message.error('请填写企业名')
        return
      }

      if (this.form.ster === true) {
        this.stutes = 1
      } else {
        this.stutes = 2
      }
      console.log(' this.stutes', this.stutes)
      const data = await wechatcompany({
        company_name: this.form.company_name,
        clock_in: this.stutes
      })
      this.$message({
        message: '添加成功',
        type: 'success'
      })
      this.accountlist()
      this.rest()
      console.log('data', data)
    },

    rest() {
      this.form.company_name = ''
    },
    modifyAccount(index, data) {
      for (let i = 0; i < this.tableData.length; i++) {
        this.tableData[i].show = false
      }
      this.tableData[index].show = true
      this.company_name = data.company_name
      this.mathRandom = Math.random()
    },
    // 取消修改
    cancelAccount(index) {
      this.tableData[index].show = false
      this.mathRandom = Math.random()
    },
    async confirmAccount(index, item) {
      const id = item.id
      const company_name = this.company_name
      const clock_in = item.clock_in
      const data = await wechatcomupdata(id, company_name, clock_in)
      this.$message({
        message: '修改成功',
        type: 'success'
      })
      this.mathRandom = Math.random()
      this.accountlist()
      this.tableData[index].show = false
      console.log('data', data)
    },
    async deleteAccount(id) {
      const data = await deletetestwechatr(id)
      this.$message({
        message: '删除成功',
        type: 'success'
      })
      this.accountlist()
      console.log('data', data)
    },

    async naclick(item) {
      console.log('item', item)
      const id = item.id
      const company_name = item.company_name
      // const clock_in = item.clock_in
      let clockin = null
      if (item.clock_in === 1) {
        clockin = 2
      } else {
        clockin = 1
      }
      const data = await wechatcomupdata(id, company_name, clockin)
      this.$message({
        message: '修改成功',
        type: 'success'
      })
      // this.mathRandom = Math.random()
      this.accountlist()
      console.log('data', data)
    },
    // 分页
    fetchPageSize(e) {
      this.query.page_size = e
      this.accountlist()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.accountlist()
    },
    resback() {
      this.rest()
    }
    // updatawechat() {
    //   this.accountlist()
    // },
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.form_box{
  margin-top: 30px;
  padding: 30px;
}
 ::v-deep .el-switch__core{
    width: 70px !important;
}
</style>
